module.exports = __webpack_public_path__ + "static/media/icon-update_save_exit.fac849e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-update_save_exit.svg
// module id = ./src/assets/images/icon-update_save_exit.svg
// module chunks = 6